module.exports = __webpack_public_path__ + "img/card_ip_stipulation42_2.8948fe32.svg";